@if (objectFit) {
  <img
    [style.object-fit]="objectFit"
    [class.rounded-corners]="hasRoundedCorners"
    [ngSrc]="src"
    [fill]="true"
    [sizes]="sizes"
    [priority]="isPriority"
    [placeholder]="showPlaceholder"
    [alt]="alt"
  />
} @else if (width && height) {
  <img
    [ngSrc]="src"
    [class.rounded-corners]="hasRoundedCorners"
    [width]="width"
    [height]="height"
    [sizes]="sizes"
    [priority]="isPriority"
    [placeholder]="showPlaceholder"
    [alt]="alt"
  />
} @else {
  <p>Either provide object-fit or width and height</p>
}
